// Startup readers can safely share the same in-flight profile snapshot. Explicit
// post-mutation readers continue to call fetchUserProfile() directly for freshness.
export const loadStartupUserProfile = backendService => (
  backendService.fetchUserProfile({ shareInFlight: true })
);
